import { types, actions } from './requests'
export const GETKITLIST_TYPES = {
    ...types('GETKITLIST'),
}
export const GETKITLIST_ACTIONS = {
    ...actions('GETKITLIST'),
}